import { inject, Directive } from '@angular/core';

import { AppDialogRef, APP_DIALOG_DATA } from '@/app/shared/components/ui/dialog';

@Directive()
export abstract class BaseDialogComponent<DialogData, DialogResult> {
  protected data: DialogData = inject(APP_DIALOG_DATA);

  protected dialogRef: AppDialogRef<BaseDialogComponent<DialogData, DialogResult>, DialogResult> = inject(AppDialogRef);

  closeModal() {
    this.dialogRef.cancel();
  }
}
